module.exports = __webpack_public_path__ + "files/a2d06f722ebe3c9a5784cc75abcc4eb1.svg";